<template>
  <div id="content-wrapper" class="content-wrapper b24-thank-you">
    <div v-if="showReferAFriend" class="show-for-medium-up raf-banner noprint">
      <h1>Share Wine | Get $50</h1>
      <a
        class="button button-solid button-inverted"
        href="/invite/"
        target="_blank"
        style="background-color: white; color: black"
        >SHARE THE LOVE</a
      >
    </div>

    <div class="page page-orderdetail">
      <div class="">
        <div
          class="columns medium-11 large-9 medium-centered end confirmation-wrapper"
        >
          <div class="clearfix">
            <div class="columns">
              <div class="ppto-payment-error form-error error"></div>

              <div class="page-title-container">
                <header class="clearfix page-title">
                  <img
                    v-if="firstInstance"
                    src="~/assets/images/wineaccess-logo-black.svg"
                    class="print-logo"
                    alt="Wine Access Logo"
                    data-not-lazy
                  />
                  <slot v-if="firstInstance" name="greeting">
                    <ul class="generic-grid">
                      <li>
                        <h1 id="order-greeting">
                          Thank you for
                          <br class="show-for-small-only" />your order<span
                            v-if="multipleInstances"
                            >s</span
                          >
                        </h1>
                      </li>
                    </ul>
                    <p
                      v-if="inEnPrimeur && multipleInstances"
                      style="margin: 0.5em"
                    >
                      Your credit card is charged separately for each En Primeur
                      wine you purchase and you will receive an individual
                      confirmation email shortly at
                      {{ order.user.email }} for each transaction.
                    </p>
                  </slot>
                  <div id="order-meta" class="order-meta">
                    <slot name="subheader">
                      <p>
                        Your order number is
                        <strong id="order-number">#{{ order.number }}</strong
                        >.
                      </p>
                    </slot>
                  </div>
                </header>
              </div>
            </div>
          </div>

          <div class="clearfix section-header">
            <div class="columns medium-7">
              <h2>Shipping &amp; Billing Details</h2>
            </div>
            <div class="columns medium-5 show-for-medium-up text-right">
              <button
                v-if="!inMobileApp && firstInstance"
                class="button button-solid max print-page hide-for-print"
                @click="print()"
              >
                Print Receipt
              </button>
            </div>
          </div>

          <div class="clearfix shipping">
            <div
              class="columns small-6 medium-3 print-3 payment-method"
              style="float: left"
            >
              <div class="title">Payment:</div>

              <template v-if="paymentMethod && paymentMethod.email">
                PayPal ({{ paymentMethod.email }})
              </template>

              <template v-else-if="paymentMethod">
                <template v-if="paymentMethod.cardholder_name"
                  >{{ paymentMethod.cardholder_name }}<br /></template
                ><span class="card-ending"
                  >{{ paymentMethod.card_type }} ending in
                  {{ paymentMethod.last_4 }}</span
                >
                <br />Exp: {{ paymentMethod.expiration_date }}
              </template>
              <template v-else> No charges. </template>
            </div>
            <div
              class="columns small-6 medium-3 print-3 shipping-address"
              style="float: left"
            >
              <div class="title">Shipping:</div>

              {{ shippingAddress.first_name }} {{ shippingAddress.last_name }}
              <br />{{ shippingAddress.line1 }}
              <template v-if="shippingAddress.line2">
                <br />{{ shippingAddress.line2 }}
              </template>

              <template v-if="shippingAddress.line3">
                <br />{{ shippingAddress.line3 }}
              </template>

              <br />{{ shippingAddress.line4 }}, {{ shippingAddress.state }}
              {{ shippingAddress.postcode }}
            </div>
            <div
              class="columns small-6 medium-3 print-3 shipping-method"
              style="float: left"
            >
              <div class="title">Shipping Method:</div>
              {{ order.shipping_method }}
              {{ order.has_child_ice_packs ? '& Perfect Temp Package' : '' }}
            </div>
            <div
              v-if="billingAddress"
              class="columns small-6 medium-3 print-3 billing-address"
              style="float: left"
            >
              <div class="title">Billing:</div>
              {{ billingAddress.billing1 }}
              <template v-if="billingAddress.billing2">
                <br />{{ billingAddress.billing2 }}
              </template>

              <br />{{ billingAddress.city }},
              {{ billingAddress.state }}
              {{ billingAddress.postcode }}
            </div>
            <div
              v-if="hotWeatherText && !inEnPrimeur"
              class="columns small-text-center medium-text-left"
              style="margin-top: 20px; font-style: italic"
            >
              {{ hotWeatherText }}
            </div>
          </div>

          <div class="clearfix delivery">
            <div class="clearfix delivery-date-status">
              <div class="columns small-text-center medium-text-left">
                <template
                  v-if="
                    order.is_prearrival && !order.is_as_you_go && !isDelayed
                  "
                >
                  Anticipated Date:
                  <strong v-if="inEnPrimeur" class="delivery-date">TBD</strong>
                  <strong v-else class="delivery-date"
                    >{{
                      getFormattedDate(order.requested_delivery_date)
                    }}*</strong
                  >
                  <div v-if="!inEnPrimeur">
                    <em>
                      *This is the anticipated date. We will contact you when
                      your order is available for shipping to confirm a delivery
                      date.
                    </em>
                  </div>
                </template>
                <template v-else-if="!order.is_as_you_go">
                  Delivery Date:
                  <strong
                    v-if="isHoldingUntilFall"
                    v-tooltip="fallShipTooltip"
                    class="delivery-date"
                    >Fall
                    {{ order.requested_delivery_date | date_year }}
                  </strong>
                  <strong v-else-if="isDelayed" class="delivery-date"
                    >TBD</strong
                  >
                  <strong v-else class="delivery-date">{{
                    getFormattedDate(order.requested_delivery_date)
                  }}</strong>
                </template>
                <template v-else>
                  Spend ${{ metadata.settingsVars.STORE_FREE_SHIPPING_DOLLARS }}
                  By:
                  <strong class="delivery-date">{{ asYouGoPlaceBy }}</strong>
                </template>
                <div v-if="!inEnPrimeur">
                  <em>Adult signature required for delivery</em>
                </div>
              </div>
              <div
                v-if="inEnPrimeur"
                class="columns small-text-center medium-text-left"
              >
                Status: <strong>Futures Order</strong>
                <br />
                Reds will ship approximately two years after ordering&mdash;and
                whites one year. We'll notify you ahead of time so you can
                update your delivery details.
              </div>
              <div
                v-else-if="isHoldingUntilFall"
                class="columns small-text-center medium-text-left"
              >
                Status:
                <strong v-tooltip="fallHoldTooltip">Holding Until Fall</strong>
              </div>
              <div v-else class="columns small-text-center medium-text-left">
                Status: <strong>{{ order.status.text }}</strong>
                <div v-if="order.gift_message">
                  Gift Note: <strong> {{ order.gift_message }} </strong>
                </div>
              </div>
            </div>

            <div class="clearfix table-header">
              <div class="columns small-6 print-6">Items</div>
              <div class="columns small-2 print-2 text-center">Qty</div>
              <div class="columns small-2 print-2 text-right">Price</div>
              <div class="columns small-2 print-2 text-right">Total</div>
            </div>

            <div
              v-for="line in orderLines"
              :key="line.product_name"
              class="table-rows"
            >
              <div class="clearfix table-row">
                <div class="columns small-6 print-6">
                  {{ line.product_name }}
                </div>
                <div class="columns small-2 print-2 text-center">
                  {{ line.quantity }}
                </div>
                <div class="columns small-2 print-2 text-right">
                  <Price :amt="Number(line.unit_price_excl_tax)" />
                </div>
                <div class="columns small-2 print-2 text-right">
                  <Price
                    :amt="Number(line.line_price_before_discounts_excl_tax)"
                  />
                </div>
              </div>
            </div>

            <div class="row hide-for-print">
              <div class="columns medium-8 large-7 end"></div>
            </div>

            <div class="clearfix seller">
              <div class="columns">
                <div class="rule"></div>
              </div>
              <div class="columns">
                <template v-if="order.passage_of_title">
                  Sold by Kachina Cellars LLC.
                  <br />
                  I understand and agree that title to the wine passes to me in
                  California upon completion of my purchase. I authorize Wine
                  Access to allow an independent fulfillment provider to fulfill
                  my order according to my directions.
                </template>
                <template v-else>
                  Sold and delivered by {{ order.winery_license_name }}
                </template>
              </div>
            </div>

            <!-- Order Total -->
            <div class="clearfix">
              <div class="columns">
                <div class="totals">
                  <div v-if="!inEnPrimeur" class="row">
                    <div class="columns small-7 print-7">Order Subtotal</div>
                    <div
                      class="columns small-5 print-5 text-right order-subtotal-amount"
                    >
                      <Price :amt="Number(lineTotal)" />
                    </div>
                  </div>
                  <div class="text-attention">
                    <template
                      v-for="(discount, index) in offerDiscounts"
                      :key="index"
                    >
                      <div class="row">
                        <div
                          v-if="discount.code"
                          class="columns small-7 print-7"
                        >
                          Promo: {{ discount.code }}
                        </div>
                        <div v-else class="columns small-7 print-7">
                          {{ discount.name }}
                        </div>
                        <div class="columns small-5 print-5 text-right">
                          - <Price :amt="discount.amount" />
                        </div>
                      </div>
                    </template>
                    <template v-if="creditsTotal > 0">
                      <div class="row">
                        <div class="columns small-7 print-7">Credits</div>
                        <div class="columns small-5 print-5 text-right">
                          - <Price :amt="creditsTotal" />
                        </div>
                      </div>
                    </template>
                  </div>

                  <div v-if="!inEnPrimeur" class="row">
                    <div class="columns small-7 print-7">Taxes</div>
                    <div
                      class="columns small-5 text-right print-5 order-taxes-amount"
                    >
                      <Price :amt="Number(taxTotal)" />
                    </div>
                  </div>
                  <div
                    v-if="serviceFeeSurchargeExclTax > 0 && !inEnPrimeur"
                    class="row"
                  >
                    <div class="columns small-7 print-7">Service Fee</div>
                    <div
                      class="columns small-5 text-right print-5 order-taxes-amount"
                    >
                      <Price :amt="Number(serviceFeeSurchargeExclTax)" />
                    </div>
                  </div>
                  <div
                    v-if="
                      icePackSurchargeExclTax > 0 ||
                      expectedIcePackSurchargeExclTax > 0
                    "
                    class="row"
                  >
                    <div class="columns small-7 print-7">
                      <img
                        v-if="metadata.constance.TCP_ECO === 'True'"
                        style="max-width: 1rem"
                        src="~/assets/images/wa-icon-eco.svg"
                        alt="Eco Packaging Icon"
                        role="presentation"
                      />
                      {{ metadata.constance.TCP_SHORTNAME }}
                    </div>
                    <div
                      v-if="icePackSurchargeExclTax > 0"
                      class="columns small-5 text-right print-5 order-taxes-amount"
                    >
                      <Price :amt="Number(icePackSurchargeExclTax)" />
                    </div>
                    <div
                      v-else
                      class="columns small-5 text-right print-5 expected-shipping"
                    >
                      <Price :amt="Number(expectedIcePackSurchargeExclTax)" />
                    </div>
                  </div>

                  <div v-if="!inEnPrimeur" class="row">
                    <div class="columns small-7 print-7">
                      {{ order.shipping_method }}
                    </div>
                    <div
                      v-if="
                        order.child_expected_shipping_cost > 0 &&
                        order.child_shipping_total > 0 &&
                        order.child_shipping_total !=
                          order.child_expected_shipping_cost
                      "
                      class="columns small-5 text-right print-5"
                    >
                      <Price
                        v-if="order.child_expected_shipping_cost > 0"
                        class="expected-shipping"
                        :amt="order.child_expected_shipping_cost"
                      />
                      <Price
                        class="other-shipping"
                        :amt="order.child_shipping_total"
                      />
                    </div>
                    <div
                      v-else-if="order.child_shipping_total > 0"
                      class="columns small-5 text-right print-5"
                    >
                      <Price :amt="Number(order.child_shipping_total)" />
                    </div>
                    <div
                      v-else-if="order.child_expected_shipping_cost > 0"
                      class="columns small-5 text-right print-5 expected-shipping"
                    >
                      <Price
                        :amt="Number(order.child_expected_shipping_cost)"
                      />
                    </div>
                  </div>

                  <div class="row total">
                    <div class="columns small-7 print-7 order-total-text">
                      Order Total
                    </div>
                    <div
                      class="columns small-5 print-5 text-right order-total-amount"
                    >
                      <Price :amt="Number(grandTotal)" />
                    </div>
                  </div>
                  <div v-if="inEnPrimeur" class="row future-note">
                    <div class="columns small-12">
                      Tax and shipping will be charged at the time of shipment.
                      All sales are final and not eligible for refunds and/or
                      credits.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Order Total -->

            <div class="row">
              <div class="columns charge-detail">
                <template v-if="grandTotal > 0">
                  <p v-if="order.has_auth_payment">
                    Your credit card has been authorized for
                    <Price :amt="Number(grandTotal)" />
                    on {{ getFormattedDate(order.date_placed) }}. The
                    authorization will appear as "{{ order.cc_statement_name }}"
                    on your credit card statement.
                  </p>
                  <p v-else>
                    Your credit card has been charged
                    <Price :amt="Number(grandTotal)" /> on
                    {{ getFormattedDate(order.date_placed) }}. The charge will
                    appear as "{{ order.cc_statement_name }}" on your credit
                    card statement.
                  </p>
                </template>
              </div>

              <div v-if="!inEnPrimeur" class="clearfix">
                <div
                  class="columns medium-6 medium-centered hide-for-print text-center"
                >
                  <a
                    href="/"
                    class="button button-solid max continue-shopping"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    Continue Shopping
                  </a>
                </div>
              </div>
            </div>
            <div v-if="!inEnPrimeur" class="row contact-weather">
              <div class="columns contact hide-for-medium-up">
                <a :href="`tel:${metadata.customerService.number}`">
                  Have Questions? Contact Us
                  <span class="nowrap">
                    {{ metadata.customerService.numberDisplay }}
                  </span>
                </a>
              </div>
              <div class="columns">
                <div class="rule"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Price from '#common/components/Price.vue'
import {
  coldPackOptions,
  hotWeatherOptions,
} from '#common/services/checkoutServices'
import ga4 from '#common/utils/ga4'
import { mapGetters } from 'vuex'

export default {
  name: 'CheckoutThankYou',
  components: { Price },
  filters: {
    date_year(val) {
      const dVal = new Date(val)
      return dVal.getFullYear('YYYY')
    },
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    showReferAFriend: {
      type: Boolean,
      default: true,
    },
    firstInstance: {
      type: Boolean,
      default: true,
    },
    multipleInstances: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['inMobileApp']),
    orderLines() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.lines
      }
      return this.order.lines
    },
    allProductIds() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.all_product_ids
      }
      return this.order.all_product_ids
    },
    totalRevenue() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.child_total_revenue
      }
      return this.order.child_total_revenue
    },
    discountsTotal() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.offer_discounts_total
      }
      return this.order.offer_discounts_total
    },
    offerDiscounts() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.offer_discounts
      }
      return this.order.offer_discounts
    },
    taxTotal() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.taxes
      }
      return this.order.child_tax_total
    },
    serviceFeeSurchargeExclTax() {
      if (this.order.ppto_order) return 0
      return this.order.service_fee_surcharge_excl_tax
    },
    icePackSurchargeExclTax() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.child_ice_pack_surcharge_excl_tax
      }
      return this.order.ice_pack_surcharge_excl_tax
    },
    expectedIcePackSurchargeExclTax() {
      if (this.order.ppto_order) return 0
      return this.order.expected_ice_pack_surcharge
    },
    grandTotal() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.total
      }
      return this.order.grand_total
    },
    lineTotal() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.subtotal
      }
      return this.order.child_line_total
    },
    creditsTotal() {
      if (this.order.ppto_order) {
        return this.order.ppto_order.credit_amount_total
      }
      return this.order.refund_credits_total
    },
    isDelayed() {
      return ['pending_weather', 'pending_waitship'].includes(
        this.order.status.slug,
      )
    },
    asYouGoPlaceBy() {
      return this.$moment()
        .add(this.metadata.settingsVars.AS_YOU_GO_PLACE_BY_DAYS, 'd')
        .format('dddd, MMMM DD YYYY')
    },
    shippingAddress() {
      return this.order.shipping_address
        ? this.order.shipping_address
        : this.order.pickup_address
    },
    paymentMethod() {
      return this.order.payment_methods ? this.order.payment_methods[0] : []
    },
    billingAddress() {
      if (this.order.payment_methods && this.order.payment_methods.length > 0) {
        return this.order.payment_methods[0].billing_address
      } else {
        return null
      }
    },
    coldPackOption() {
      return coldPackOptions.find((x) => x.apiValue === this.order.use_ice_pack)
    },
    hotWeatherOption() {
      return hotWeatherOptions.find(
        (x) => x.apiValue === this.order.cold_pack_option,
      )
    },
    hotWeatherText() {
      if (
        !this.hotWeatherOption ||
        !this.coldPackOption ||
        this.metadata.constance.DISPLAY_HOT_WEATHER !== 'True'
      ) {
        return ''
      } else if (
        this.order.is_hot_weather_shipment && // summer
        this.hotWeatherOption &&
        this.hotWeatherOption.apiValue === 1 // ship when safe
      ) {
        return ''
      } else if (
        !this.order.is_hot_weather_shipment && // not summer
        this.hotWeatherOption &&
        this.hotWeatherOption.apiValue === 1 // ship when safe
      ) {
        return 'Unfavorable Weather Shipping - In case of unseasonably warm or extremely cold temperatures, your order may be delayed to protect the condition of the wine. We’ll contact you if this occurs.'
      } else if (
        this.hotWeatherOption &&
        this.hotWeatherOption.apiValue === 3 // just ship it
      ) {
        return "Unfavorable Weather Shipping - You selected to ship this order at your own risk, regardless of temperatures, so we cannot guarantee that extreme temperatures won't impact the quality of your wine during delivery."
      }
      return ''
    },
    inEnPrimeur() {
      return this.$route.path.includes('en-primeur')
    },
    fallShipTooltip() {
      const shipDateStr = this.$moment(this.order.expected_ship_date).format(
        'dddd, MMM Do',
      )
      return `Your wine will ship once the hot weather subsides—approximately ${shipDateStr}.`
    },
    fallHoldTooltip() {
      return 'Your order is being held until Fall when temperatures subside. We will notify you when your order is ready to ship.'
    },
    isHoldingUntilFall() {
      return this.order.status.slug === 'pending_fall_release'
    },
    ...mapGetters(['productNotifications']),
  },
  mounted() {
    this.$store.dispatch('getPromoBanner')
    ga4.trackPurchase(this.order, this.$auth)
    this.track_affiliate_marketing()
    this.updateNotifications()
  },
  created() {
    this.metadata = useMetadata()
  },
  methods: {
    // Remove notifications for any wines that were successfully ordered
    updateNotifications() {
      this.productNotifications.forEach((x) => {
        const found = this.allProductIds.find(
          (pid) => pid === x.product.product_id,
        )
        if (found) {
          this.$store.dispatch('removeNotification', x)
        }
      })
    },
    getFormattedDate(date) {
      return this.$moment(date).format('dddd, MMM DD')
    },
    print(e) {
      window.print()
    },
    track_affiliate_marketing() {
      const customerStatus =
        this.order.user.new_or_returning_customer === 'New' ? 'New' : 'Existing'
      const productData = this.orderLines.map((line) => ({
        quantity: line.quantity,
        unitPrice: line.unit_price_incl_tax,
        unitPriceLessTax: line.unit_price_excl_tax,
        SKU: line.product.id,
        productName: line.description,
        optionalData: {
          cat: line.earmark_name,
        },
      }))
      /* eslint-disable */
      var rm_trans = {
        affiliateConfig: {
          ranMID: '42973',
          discountType: 'item',
          includeStatus: true,
        },
        orderid: this.order.number,
        currency: 'USD',
        customerStatus,
        conversionType: 'Sale',
        customerID: this.$auth.user.id,
        discountCode: '',
        discountAmount: this.discountsTotal,
        taxAmount: this.taxTotal,
        optionalData: {
          custstatus: customerStatus,
        },
        lineitems: productData,
      }
      if (!window.DataLayer) {
        window.DataLayer = { Sale: { Basket: rm_trans } }
      } else {
        DataLayer.Sale = DataLayer.Sale || { Basket: rm_trans }
        DataLayer.Sale.Basket = DataLayer.Sale.Basket || rm_trans
      }
      DataLayer.Sale.Basket.Ready = true
      function __readRMCookie(e) {
        for (
          var a = e + '=', t = document.cookie.split(';'), r = 0;
          r < t.length;
          r++
        ) {
          for (var i = t[r]; ' ' == i.charAt(0); ) i = i.substring(1, i.length)
          if (0 == i.indexOf(a)) return i.substring(a.length, i.length)
        }
        return ''
      }
      function __readRMCookiev2(e, a) {
        for (
          var t = __readRMCookie((a = a || 'rmStore'));
          t !== decodeURIComponent(t);

        )
          t = decodeURIComponent(t)
        for (var r = t.split('|'), i = 0; i < r.length; i++) {
          var n = r[i].split(':')[0],
            o = r[i].split(':')[1]
          if (n === e) return o
        }
        return ''
      }
      function __readParam(e, a, t, r) {
        var i = e || '',
          n = a || '',
          o = t || '',
          s = r || {},
          d = __readRMCookiev2(i),
          u = s[n],
          m = (d = s.ignoreCookie ? 0 : d) || u || o
        return (m = ('string' != typeof m || 'false' !== m.toLowerCase()) && m)
      }
      function sRAN() {
        var e =
            DataLayer && DataLayer.Sale && DataLayer.Sale.Basket
              ? DataLayer.Sale.Basket
              : {},
          a = e.affiliateConfig || {},
          t = __readParam('atm', 'tagType', 'pixel', a),
          r = __readParam('adr', 'discountType', 'order', a),
          i = __readParam('acs', 'includeStatus', 'false', a),
          n = __readParam('arto', 'removeOrderTax', 'false', a),
          o = __readParam('artp', 'removeTaxFromProducts', 'false', a),
          s = __readParam('artd', 'removeTaxFromDiscount', 'false', a),
          d = __readParam('atr', 'taxRate', 0, a)
        d = Number(d)
        var u =
            __readParam('ald', 'land', !1, {}) ||
            (a.land && !0 === a.land
              ? __readRMCookie('ranLandDateTime')
              : a.land) ||
            !1,
          m =
            __readParam('atrv', 'tr', !1, {}) ||
            (a.tr && !0 === a.tr ? __readRMCookie('ranSiteID') : a.tr) ||
            !1,
          l = !1,
          c = __readParam('amid', 'ranMID', '', a) || e.ranMID
        if (!c) return !1
        if (
          !(
            void 0 === a.allowCommission ||
            ('false' !== a.allowCommission && a.allowCommission)
          )
        )
          return !1
        var p = e.orderid || 'OrderNumberNotAvailable',
          f = '',
          y = '',
          v = '',
          _ = '',
          h = e.currency || '',
          g = e.taxAmount ? Math.abs(Math.round(100 * Number(e.taxAmount))) : 0,
          N = e.discountAmount
            ? Math.abs(Math.round(100 * Number(e.discountAmount)))
            : 0
        if (s && d)
          var C = (100 + Number(d)) / 100,
            N = Math.round(N / C)
        var w = 'pixel' === t ? 'ep' : 'mop' === t ? 'eventnvppixel' : 'ep',
          D = e.customerStatus || '',
          S = document.location.protocol + '//track.linksynergy.com/' + w + '?',
          b = ''
        null != D &&
          '' != D &&
          ((i && 'EXISTING' == D.toUpperCase()) ||
            (i && 'RETURNING' == D.toUpperCase())) &&
          (b = 'R_')
        for (
          var P = [], x = 0, k = 0;
          k < (e.lineitems ? e.lineitems.length : 0);
          k++
        ) {
          for (
            var T = !1,
              L = window.JSON
                ? JSON.parse(JSON.stringify(e.lineitems[k]))
                : e.lineitems[k],
              R = 0;
            R < P.length;
            R++
          )
            P[R].SKU === L.SKU &&
              ((T = !0),
              (P[R].quantity = Number(P[R].quantity) + Number(L.quantity)))
          T || P.push(L),
            (x +=
              Number(L.quantity) *
              Number(L.unitPriceLessTax || L.unitPrice) *
              100)
        }
        for (var I = {}, k = 0; k < P.length; k++) {
          var L = P[k],
            M = encodeURIComponent(L.SKU),
            A = L.unitPriceLessTax || L.unitPrice,
            O = L.quantity,
            U = encodeURIComponent(L.productName) || '',
            E = Math.round(Number(A) * Number(O) * 100)
          if (
            (!o ||
              !d ||
              (L.unitPriceLessTax && L.unitPriceLessTax !== L.unitPrice) ||
              (E /= C = (100 + d) / 100),
            'item' === r.toLowerCase() && N && (E -= (N * E) / x),
            L.optionalData)
          ) {
            q = L.optionalData
            for (var B in q)
              q.hasOwnProperty(B) && ((I[B] = I[B] || ''), (I[B] += q[B] + '|'))
          }
          ;(f += b + M + '|'),
            (y += O + '|'),
            (v += Math.round(E) + '|'),
            (_ += b + U + '|')
        }
        ;(f = f.slice(0, -1)),
          (y = y.slice(0, -1)),
          (v = v.slice(0, -1)),
          (_ = _.slice(0, -1)),
          N && 'order' === r.toLowerCase()
            ? ((f += '|' + b + 'DISCOUNT'),
              (_ += '|' + b + 'DISCOUNT'),
              (y += '|0'),
              (v += '|-' + N))
            : N && 'item' === r.toLowerCase() && (l = !0),
          n &&
            g &&
            ((f += '|' + b + 'ORDERTAX'),
            (y += '|0'),
            (v += '|-' + g),
            (_ += '|' + b + 'ORDERTAX')),
          (S +=
            'mid=' +
            c +
            '&ord=' +
            p +
            '&skulist=' +
            f +
            '&qlist=' +
            y +
            '&amtlist=' +
            v +
            '&cur=' +
            h +
            '&namelist=' +
            _ +
            '&img=1&'),
          u && (S += 'land=' + u + '&'),
          m && (S += 'tr=' + m + '&'),
          l && (S += 'discount=' + N + '&')
        try {
          S +=
            'caduid=' +
            (B = document.cookie.slice(
              document.cookie.match('stc[0-9]{6}=.*;').index
            ))
              .split(';')[0]
              .match('uid:[0-9.]*')[0]
              .split(':')[1] +
            '&'
        } catch (e) {}
        var q = e.optionalData || {}
        for (var B in q) q.hasOwnProperty(B) && (S += B + '=' + q[B] + '&')
        for (var B in I)
          I.hasOwnProperty(B) && (S += B + 'list=' + I[B].slice(0, -1) + '&')
        '&' === S[S.length - 1] && (S = S.slice(0, -1)),
          S.length >= 2048 && ((S = S.slice(0, 2037)), (S += '&trunc=true'))
        var j,
          G = document.createElement('img')
        G.setAttribute('src', S),
          G.setAttribute('height', '1px'),
          G.setAttribute('width', '1px'),
          (j = document.getElementsByTagName(
            'script'
          )[0]).parentNode.insertBefore(G, j)
      }
      function sDisplay() {
        var e = null,
          a = null,
          t = null,
          r = null,
          i =
            window.DataLayer &&
            window.DataLayer.Sale &&
            window.DataLayer.Sale.Basket
              ? window.DataLayer.Sale.Basket
              : {},
          n = i.displayConfig || {},
          o = i.customerStatus || '',
          s = i.discountAmount ? Math.abs(Number(i.discountAmount)) : 0,
          d = __readParam('dmid', 'rdMID', '', n)
        if (!d) return !1
        var u = __readParam('dtm', 'tagType', 'js', n),
          m =
            'if' === (u = 'js' === u || 'if' === u || 'img' === u ? u : 'js')
              ? 'iframe'
              : 'img' === u
              ? u
              : 'script',
          l =
            '//' +
            __readParam('ddn', 'domain', 'tags.rd.linksynergy.com', n) +
            '/' +
            u +
            '/' +
            d,
          c = __readParam('dis', 'includeStatus', 'false', n),
          p = ''
        if (
          (null != o &&
            '' != o &&
            ((c && 'EXISTING' == o.toUpperCase()) ||
              (c && 'RETURNING' == o.toUpperCase())) &&
            (p = 'R_'),
          !i.orderid || 'sale' !== i.conversionType.toLowerCase())
        )
          return !1
        ;(t = 0), (a = p + i.orderid), (e = ''), (r = 'conv')
        for (var f = 0; f < (i.lineitems ? i.lineitems.length : 0); f++)
          (t +=
            Number(i.lineitems[f].unitPrice) * Number(i.lineitems[f].quantity)),
            (e += i.lineitems[f].SKU + ',')
        ;(t = Math.round(100 * (t - s)) / 100),
          (e = e.slice(0, -1)) &&
            (l =
              l.indexOf('?') > -1 ? l + '&prodID=' + e : l + '/?prodID=' + e),
          a &&
            (l =
              l.indexOf('?') > -1
                ? l + '&orderNumber=' + a
                : l + '/?orderNumber=' + a),
          t &&
            (l = l.indexOf('?') > -1 ? l + '&price=' + t : l + '/?price=' + t),
          (l = l.indexOf('?') > -1 ? l + '&pt=' + r : l + '/?pt=' + r)
        var y = document.createElement(m)
        ;(y.src = l),
          'script' === m
            ? (y.type = 'text/javascript')
            : 'iframe' === m && y.setAttribute('style', 'display: none;'),
          document.getElementsByTagName('body')[0].appendChild(y)
      }
      function sSearch() {
        var e =
            window.DataLayer &&
            window.DataLayer.Sale &&
            window.DataLayer.Sale.Basket
              ? window.DataLayer.Sale.Basket
              : {},
          a = e.searchConfig || {},
          t = __readParam('smid', 'rsMID', '', a)
        if (!t) return !1
        var r = function () {
            var r = e.discountAmount ? Math.abs(Number(e.discountAmount)) : 0,
              i = __readParam('sct', 'conversionType', 'conv', a),
              n = 0,
              o = ''
            if (!e.orderid) return !1
            ;(n = 0), (o = e.orderid)
            for (var s = 0; s < (e.lineitems ? e.lineitems.length : 0); s++)
              n +=
                Number(e.lineitems[s].unitPrice) *
                Number(e.lineitems[s].quantity)
            ;(n = Math.round(100 * (n - r)) / 100), window.DataLayer.Sale.Basket
            var d = []
            ;(d[0] = 'id=' + t),
              (d[1] = 'type=' + i),
              (d[2] = 'val=' + n),
              (d[3] = 'orderId=' + o),
              (d[4] = 'promoCode=' + e.discountCode || ''),
              (d[5] = 'valueCurrency=' + e.currency || 'USD'),
              (d[6] = 'GCID='),
              (d[7] = 'kw='),
              (d[8] = 'product='),
              k_trackevent(d, '113')
          },
          i =
            document.location.protocol.indexOf('s') > -1
              ? 'https://'
              : 'http://'
        i += '113.xg4ken.com/media/getpx.php?cid=' + t
        var n = document.createElement('script')
        ;(n.type = 'text/javascript'),
          (n.src = i),
          (n.onload = r),
          (n.onreadystatechange = function () {
            ;('complete' != this.readyState && 'loaded' != this.readyState) ||
              r()
          }),
          document.getElementsByTagName('head')[0].appendChild(n)
      }
      sDisplay(), sSearch(), sRAN()
      /* eslint-enable */
    },
  },
}
</script>
